import { render, staticRenderFns } from "./GCashSuccessPageView.vue?vue&type=template&id=52770831&"
import script from "./GCashSuccessPageView.vue?vue&type=script&lang=js&"
export * from "./GCashSuccessPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports